export const iconFontAwesomeNatureIcicles = (
	<i className="fa-solid fa-icicles"></i>
);
